<template>
    <div
        class="Rating"
    >
        <span class="Rating-text">
            {{ rating.score }}
        </span>
        <span
            class="Rating-star f2m-star"
            :class="{
                'Rating-star--active': rating.score >= 0.5,
            }"
        />
        <span
            class="Rating-star f2m-star"
            :class="{
                'Rating-star--active': rating.score >= 1.5,
            }"
        />
        <span
            class="Rating-star f2m-star"
            :class="{
                'Rating-star--active': rating.score >= 2.5,
            }"
        />
        <span
            class="Rating-star f2m-star"
            :class="{
                'Rating-star--active': rating.score >= 3.5,
            }"
        />
        <span
            class="Rating-star f2m-star"
            :class="{
                'Rating-star--active': rating.score >= 4.5,
            }"
        />
        <span class="Rating-text">
            {{ rating.total }} {{ $t('personal-account.ride.rating.reviews') }}
        </span>
    </div>
</template>
<script>
export default {
    props: {
        rating: {
            type: Object,
            required: true
        }
    },
};
</script>

<style lang="scss" scoped>
.Rating {
    display: flex;
    gap: 5px;
    align-items: center;
    justify-content: flex-start;


    &-star {
        color: $color-f2m-purple-icon;
        font-size: 14px;
        &--active {
            color: $color-f2m-pink;
        }
    }

    &-text {
        font-size: 14px;
        line-height: 17px;
        color: $color-f2m-purple-icon;
    }
}

</style>
